import { CRM } from "@/simple-crm/root/CRM";

/**
 * Application entry point
 *
 * Customize Simple CRM by passing props to the CRM component:
 *  - contactGender
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
  <CRM
    title="SimpleCRM"
    lightModeLogo="./logos/simple-crm-final.svg"
    darkModeLogo="./logos/simple-crm-final-dark.svg"
  />
);

export default App;
